/* Vuex mutations types for module App */
export const TOGGLE_PENDING_ASYNC_STORE_ACTIONS = 'TOGGLE_PENDING_ASYNC_STORE_ACTIONS';
export const TOOGLE_SOCKET_CONNECTION = 'TOOGLE_SOCKET_CONNECTION';
